// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rbX2","icon":"styles_icon__nfMNT"};